module.exports = {"441284001":"城中街道","441284002":"东城街道","441284003":"贞山街道","441284100":"龙甫镇","441284101":"地豆镇","441284102":"威整镇","441284103":"罗源镇","441284104":"迳口镇","441284105":"大沙镇","441284107":"石狗镇","441284108":"黄田镇","441284110":"江谷镇","441284113":"下茆镇","441284400":"广东省济广监狱","441284450":"肇庆高新技术产业开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441284.json
// module id = 2144
// module chunks = 0